import { api } from './index';

export interface User {
  id: string;
  fullName: string;
  email: string;
  role: 'ADMIN' | 'PROCUREMENT_OFFICER' | 'BID_COMMITTEE_MEMBER' | 'CEO' | 'VIEWER' | 'HEAD_OF_PROCUREMENT';
  createdAt: string;
  updatedAt: string;
}

export interface MyProfile {
  id: string;
  fullName: string;
  fullNameDhivehi: string | null;
  email: string;
  role: 'ADMIN' | 'PROCUREMENT_OFFICER' | 'BID_COMMITTEE_MEMBER' | 'CEO' | 'VIEWER' | 'HEAD_OF_PROCUREMENT';
  createdAt: string;
  updatedAt: string;
  signatureId: string | null;
  signatureUploadedAt: string | null;
}

export interface CreateUserDto {
  fullName: string;
  email: string;
  password: string;
  role: 'ADMIN' | 'PROCUREMENT_OFFICER' | 'BID_COMMITTEE_MEMBER' | 'CEO' | 'VIEWER' | 'HEAD_OF_PROCUREMENT';
}

export interface UpdateMyProfileDto {
  fullNameDhivehi?: string | null;
}

export interface UpdateUserDto {
  fullName?: string;
  fullNameDhivehi?: string | null;
  email?: string;
  password?: string;
  role?: 'ADMIN' | 'PROCUREMENT_OFFICER' | 'BID_COMMITTEE_MEMBER' | 'CEO' | 'VIEWER' | 'HEAD_OF_PROCUREMENT';
}

export const userApi = {
  // List all users
  listUsers: async (): Promise<User[]> => {
    const response = await api.get('/users');
    return response.data;
  },

  // Get user by ID
  getUserById: async (id: string): Promise<User> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // Create a new user
  createUser: async (data: CreateUserDto): Promise<User> => {
    const response = await api.post('/users', data);
    return response.data;
  },

  // Update a user
  updateUser: async (id: string, data: UpdateUserDto): Promise<User> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  // Delete a user
  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  getMyProfile: async (): Promise<MyProfile> => {
    const response = await api.get('/users/me');
    return response.data;
  },

  updateMyProfile: async (data: UpdateMyProfileDto): Promise<MyProfile> => {
    const response = await api.patch('/users/me', data);
    return response.data;
  },

  uploadMySignature: async (file: File): Promise<{ message: string; profile: MyProfile }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/users/me/signature', formData);
    return response.data;
  },

  getMySignature: async (): Promise<Blob | null> => {
    try {
      const response = await api.get('/users/me/signature', {
        responseType: 'blob',
      });
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  // Get users for evaluation report (allows PROCUREMENT_OFFICER, HEAD_OF_PROCUREMENT, ADMIN)
  getUsersForEvaluationReport: async (): Promise<User[]> => {
    const response = await api.get('/users/for-evaluation-report');
    return response.data;
  },
};

